<template>
  <div class="min-h-screen bg-gradient-to-b from-cream to-white py-8 sm:py-12">
    <div class="container mx-auto px-4" style="max-width: 520px;">
      <!-- Header -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
          <svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
        <h1 class="text-2xl sm:text-3xl font-bold text-gray-800">ติดตามสถานะคำสั่งซื้อ</h1>
        <p class="text-gray-500 mt-2">กรอกข้อมูลเพื่อตรวจสอบสถานะคำสั่งซื้อของคุณ</p>
      </div>

      <!-- Search Form -->
      <div class="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
        <div class="p-6 sm:p-8">
          <Form @submit="searchOrder" :validation-schema="trackingSchema" v-slot="{ errors, isSubmitting }">
            <div class="space-y-5">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  <span class="flex items-center gap-2">
                    <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/>
                    </svg>
                    หมายเลขคำสั่งซื้อ
                  </span>
                </label>
                <Field 
                  name="order_number"
                  v-model="orderNumber"
                  type="text" 
                  class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-gray-800 placeholder-gray-400"
                  :class="{ 'border-red-400 focus:border-red-400 focus:ring-red-100': errors.order_number }"
                  placeholder="เช่น ORD-XXXXXXXXX"
                />
                <ErrorMessage name="order_number" class="text-red-500 text-sm mt-1.5 flex items-center gap-1" v-slot="{ message }">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  {{ message }}
                </ErrorMessage>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  <span class="flex items-center gap-2">
                    <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                    หมายเลขโทรศัพท์
                  </span>
                </label>
                <Field 
                  name="phone"
                  v-model="phone"
                  type="text" 
                  class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-gray-800 placeholder-gray-400"
                  :class="{ 'border-red-400 focus:border-red-400 focus:ring-red-100': errors.phone }"
                  placeholder="เช่น 0812345678"
                />
                <ErrorMessage name="phone" class="text-red-500 text-sm mt-1.5 flex items-center gap-1" v-slot="{ message }">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  {{ message }}
                </ErrorMessage>
              </div>

              <button 
                type="submit" 
                class="w-full bg-primary hover:bg-primary-dark text-white font-semibold py-3.5 px-6 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 disabled:opacity-60 disabled:cursor-not-allowed"
                :disabled="isSubmitting"
              >
                <svg v-if="isSubmitting" class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
                {{ isSubmitting ? 'กำลังค้นหา...' : 'ค้นหาคำสั่งซื้อ' }}
              </button>
            </div>
          </Form>
        </div>
      </div>

      <!-- Result -->
      <div v-if="order" class="mt-6 space-y-4 animate-fade-in">
        <!-- Order Header Card -->
        <div class="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div class="p-6">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div>
                <p class="text-sm text-gray-500 mb-1">คำสั่งซื้อ</p>
                <h2 class="text-xl font-bold text-primary">#{{ order.order_number }}</h2>
                <p class="text-sm text-gray-500 mt-1">{{ formatDate(order.created_at) }}</p>
              </div>
              <span :class="getStatusClasses(order.status)">
                {{ getStatusText(order.status) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Shipping Info Card -->
        <div class="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div class="px-6 py-4 border-b border-gray-100 bg-gray-50">
            <h3 class="font-semibold text-gray-800 flex items-center gap-2">
              <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              ข้อมูลจัดส่ง
            </h3>
          </div>
          <div class="p-6">
            <div class="space-y-3">
              <div class="flex items-start gap-3">
                <div class="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center shrink-0">
                  <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  </svg>
                </div>
                <div>
                  <p class="text-xs text-gray-500 uppercase tracking-wide">ที่อยู่</p>
                  <p class="text-gray-800">{{ order.address }}</p>
                </div>
              </div>
              <div class="flex items-start gap-3">
                <div class="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                </div>
                <div>
                  <p class="text-xs text-gray-500 uppercase tracking-wide">โทรศัพท์</p>
                  <p class="text-gray-800">{{ order.phone }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tracking Info Card -->
        <div v-if="order.shipping?.tracking_number" class="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl shadow-lg border border-amber-200 overflow-hidden">
          <div class="px-6 py-4 border-b border-amber-200 bg-amber-100/50">
            <h3 class="font-semibold text-amber-800 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
              </svg>
              ข้อมูลพัสดุ
            </h3>
          </div>
          <div class="p-6">
            <div class="flex items-center gap-4 mb-4">
              <div class="w-12 h-12 rounded-full bg-amber-200 flex items-center justify-center">
                <svg class="w-6 h-6 text-amber-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                </svg>
              </div>
              <div>
                <p class="text-xs text-amber-700 uppercase tracking-wide">เลขพัสดุ</p>
                <p class="text-xl font-bold text-amber-900">{{ order.shipping.tracking_number }}</p>
                <p v-if="order.shipping.company_name" class="text-sm text-amber-700 mt-0.5">
                  ขนส่ง: {{ order.shipping.company_name }}
                </p>
              </div>
            </div>
            
            <!-- Parcel Image -->
            <div v-if="order.shipping.parcel_image_url || order.shipping.parcel_image_path" class="mt-4 pt-4 border-t border-amber-200">
              <p class="text-sm font-medium text-amber-800 mb-3">รูปพัสดุ</p>
              <a :href="getImageUrl(order.shipping.parcel_image_url || order.shipping.parcel_image_path)" target="_blank" class="block group">
                <div class="relative overflow-hidden rounded-xl border-2 border-amber-200 bg-white">
                  <img 
                    :src="getImageUrl(order.shipping.parcel_image_url || order.shipping.parcel_image_path)" 
                    alt="รูปพัสดุ" 
                    class="w-full max-h-64 object-contain group-hover:scale-105 transition-transform duration-300"
                  >
                  <div class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <svg class="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- Payment Action -->
        <div v-if="order.status === 'pending_payment'" class="bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl shadow-lg border border-primary/20 overflow-hidden">
          <div class="p-6 text-center">
            <div class="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">รอการชำระเงิน</h3>
            <p class="text-gray-600 mb-4">กรุณาชำระเงินเพื่อดำเนินการคำสั่งซื้อ</p>
            <router-link 
              :to="`/order/${order.order_number}`" 
              class="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-6 rounded-xl transition-all shadow-lg shadow-primary/25"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
              </svg>
              แจ้งชำระเงิน
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import api from '../api';
import { useNotification } from '../composables/useNotification';
import { getOrderStatusLabel } from '../utils/orderStatus';
import { getImageUrl } from '../utils/imageUrl';

const route = useRoute();
const { showError } = useNotification();

const orderNumber = ref('');
const phone = ref('');
const order = ref(null);

const trackingSchema = yup.object({
  order_number: yup.string().required('กรุณากรอกหมายเลขคำสั่งซื้อ'),
  phone: yup.string().required('กรุณากรอกหมายเลขโทรศัพท์')
});

const searchOrder = async (values) => {
  try {
    const response = await api.post('/orders/track', {
      order_number: values.order_number,
      phone: values.phone
    });
    order.value = response.data.data;
  } catch (error) {
    order.value = null;
    if (error.response?.status === 404) {
      showError('ไม่พบคำสั่งซื้อนี้ หรือหมายเลขโทรศัพท์ไม่ถูกต้อง');
    } else {
      showError('เกิดข้อผิดพลาดในการค้นหา');
    }
  }
};

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const getStatusClasses = (status) => {
  const classes = {
    'pending_payment': 'px-4 py-2 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-800 border border-yellow-200',
    'pending_verification': 'px-4 py-2 rounded-full text-sm font-semibold bg-orange-100 text-orange-800 border border-orange-200',
    'paid': 'px-4 py-2 rounded-full text-sm font-semibold bg-green-100 text-green-800 border border-green-200',
    'processing': 'px-4 py-2 rounded-full text-sm font-semibold bg-blue-100 text-blue-800 border border-blue-200',
    'shipped': 'px-4 py-2 rounded-full text-sm font-semibold bg-purple-100 text-purple-800 border border-purple-200',
    'delivered': 'px-4 py-2 rounded-full text-sm font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200',
    'cancelled': 'px-4 py-2 rounded-full text-sm font-semibold bg-red-100 text-red-800 border border-red-200'
  };
  return classes[status] || 'px-4 py-2 rounded-full text-sm font-semibold bg-gray-100 text-gray-800 border border-gray-200';
};

const getStatusText = (status) => getOrderStatusLabel(status);

onMounted(() => {
  if (route.params.orderNumber) {
    orderNumber.value = route.params.orderNumber;
  }
});
</script>

<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}
</style>
